import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import ProtectedRoute from "./route/ProtectedRoute";
import NavigationBar from "./components/NavigationBar";
import Login from "./components/Login";
import Upload from "./components/Upload";
import Logout from "./components/Logout";
import Dashboard from "./components/Dashboard";
import Register from "./components/Register";
import Home from "./components/Home";
import RegisterSuccessfulResult from "./components/RegisterResult";
import PolicySupportTool from "./components/PolicySupportTool";
import PolicySupportToolResult from "./components/PolicySupportToolResult";
import {useState, useEffect} from "react";
import { createBrowserHistory } from "history";
import ReactGA from "react-ga";
import BackCasting from "./components/BackCasting";
import BackCastingResult from "./components/BackCastingResult";
import SecondMeasureResult from "./components/SecondMeasureResult";
import Knowledge from "./components/Knowledge";
import ProjectDeliverables from "./components/ProjectDeliverables";
import Documentation from "./components/Documentation";
import Calculator from "./components/Calculator";
import CalculatorResult from "./components/CalculatorResult";
import KnowledgeDocumentation from "./components/KnowledgeDocumentation"

ReactGA.initialize('UA-16973881-4');
const browserHistory = createBrowserHistory();
browserHistory.listen((location, action) => {
    ReactGA.pageview(location.pathname + location.search)
});

function App() {

    const [authenticated, setAuthenticated] = useState();

    useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search)
    }, []);

    return (<Router>
            <div className="App">
                {/*<div className="row">*/}
                {/*    <NavigationBar setAuthenticated={setAuthenticated} />*/}
                {/*</div>*/}
                <div className="row">
                    <div className="outer">
                        <div className="inner">
                            <Switch>
                                <Route exact path="/" component={Home}/>
                                <Route exact path="/login">
                                    <Login setAuthenticated={setAuthenticated}/>
                                </Route>
                                <Route exact path='/logout'>
                                    <Logout setAuthenticated={setAuthenticated}/>
                                </Route>
                                <Route path="/home" component={Home}/>
                                <Route path="/register" component={Register}/>
                                <Route path="/success_register" component={RegisterSuccessfulResult}/>
                                <Route path="/pst" component={PolicySupportTool}/>
                                <Route path="/pstResult" component={PolicySupportToolResult}/>
                                <Route path="/secondMeasure" component={SecondMeasureResult}/>
                                <Route path="/back_casting" component={BackCasting}/>
                                <Route path="/back_casting_result" component={BackCastingResult}/>
                                <Route path="/knowledge" component={Knowledge}/>
                                <Route path="/knowledge_documentation" component={KnowledgeDocumentation}/>
                                <Route path="/project_deliverables" component={ProjectDeliverables}/>
                                <Route path="/documentation" component={Documentation}/>
                                <Route path="/calculator" component={Calculator}/>
                                <Route path="/calculatorResult" component={CalculatorResult}/>
                                <ProtectedRoute exact path='/upload' component={Upload}/>
                                <ProtectedRoute exact path='/dashboard' component={Dashboard}/>
                                <Route path="*">
                                    <div>404 Not found</div>
                                </Route>
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
        </Router>
    );
}

export default App;
